<scf-common-form
  [title]="'tariffs.interest.title'"
  [isTariffDisplayed]="true"
  (sendForm)="getInterestCommerceTariff($event)"
></scf-common-form>

<mat-card *ngIf="dataSource.data?.length > 0 && tariffSheetRequest">
  <h3>{{ tariffSheetRequest.commercialProduct.value + ' - ' + tariffSheetRequest.establishment.value }}</h3>
  <h3>{{ tariffSheetRequest.tariffs[0].code + ' - ' + tariffSheetRequest.tariffs[0].description }}</h3>
  <mat-card-content>
    <div class="table__wrapper">
      <table aria-label="interest" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="terms">
          <th mat-header-cell class="first-row" *matHeaderCellDef translate>tariffs.interest.term</th>
          <td mat-cell class="first-row" *matCellDef="let element">{{ element.termCon }}</td>
        </ng-container>

        <ng-container matColumnDef="coefficient">
          <th mat-header-cell *matHeaderCellDef translate>tariffs.interest.coefficient</th>
          <td mat-cell *matCellDef="let element">{{ element.coefCon }}</td>
        </ng-container>

        <ng-container matColumnDef="tin">
          <th mat-header-cell *matHeaderCellDef translate>tariffs.interest.tin</th>
          <td mat-cell *matCellDef="let element">{{ element.strTinT }}</td>
        </ng-container>

        <ng-container matColumnDef="fee">
          <th mat-header-cell *matHeaderCellDef translate>tariffs.interest.fee</th>
          <td mat-cell *matCellDef="let element">{{ element.porapeCon }}</td>
        </ng-container>

        <ng-container matColumnDef="discount">
          <th mat-header-cell *matHeaderCellDef translate>tariffs.interest.discount</th>
          <td mat-cell *matCellDef="let element">{{ element.imdees }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="isDataObtainedEmpty">
  <mat-card-content>
    <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
      <mat-label class="panel-request__label-no-operation" translate>investDetail.noOperations</mat-label>
    </div>
  </mat-card-content>
</mat-card>

<div *ngIf="tariffSheetRequest" class="panel_footer__buttons">
  <button
    id="btnExportExcel"
    mat-stroked-button
    color="accent"
    (click)="createExcel()"
    [disabled]="dataSource.data?.length === 0"
  >
    <mat-icon class="icon-ic_file_download"></mat-icon>
    <span>{{ 'request.button.excel' | translate | uppercase }}</span>
  </button>
  <button
    id="btnPrintPDF"
    mat-stroked-button
    color="accent"
    (click)="createPdf()"
    [disabled]="dataSource.data?.length === 0"
  >
    <mat-icon class="icon-ic_print"></mat-icon>
    <span>{{ 'request.button.print' | translate | uppercase }}</span>
  </button>
</div>
